export const MAIN_DATASOURCE_NAME = '';

export const XSOLN_PREFIX = 'x-soln:///';
